(function () {
    class LandingPageDetails {
        constructor(
            $scope,
            $state,
            moment,
            notify,
            ErrorService,
            LandingPagesService,
            PermissionService
        ) {
            this._state = $state;
            this.moment = moment;
            this.landingPagesService = LandingPagesService;
            this.errorService = ErrorService;
            this.permissionService = PermissionService
            this.notify = notify;
            this.isStartDatePickerOpen = false;
            this.isEndDatePickerOpen = false;

            this.datePickerOptions = {
                formatYear: 'yy',
                startingDay: 1,
                showWeeks: false,
                dateDisabled: false,
                showDatePicker: false
            };

            this.startDateOptions = {
                ...this.datePickerOptions,
                minDate: moment().toDate()
            };

            this.pageId = $state.params.pageId;
            this.brandId = $state.params.brandId;
            this.editing = !!this.pageId;

            this.checkPermissions();

            if (this.editing) {
                this.fetch();
            }

            if (!this.editing) {
                this.startDate = moment()
                    .startOf("day")
                    .utc()
                    .toDate();
                this.endDate = moment(this.startDate)
                    .endOf("day")
                    .utc()
                    .add(3, "months")
                    .add(1, "day")
                    .toDate();
            }
        }

        checkPermissions() {
            if (this.editing) {
                const canEditPage = this.permissionService.doesUserHaveAnyPermission([Dashboard.Models.Lookups.Permissions.EditLandingPage])
                this.disableNextButton = !canEditPage;
                return;
            }
            const canAddPage = this.permissionService.doesUserHaveAnyPermission([Dashboard.Models.Lookups.Permissions.AddLandingPage])
            this.disableNextButton = !canAddPage;
        }

        fetch() {
            this.landingPagesService.fetchLandingPageById(this.pageId)
                .then((data) => {
                    this.landingPage = data;
                    this.title = data.Title;
                    this.description = data.Description;
                    this.startDate = this.moment(data.StartDate)
                        .startOf("day")
                        .utc()
                        .toDate();
                    this.endDate = this.moment(data.EndDate)
                        .endOf("day")
                        .utc()
                        .toDate();
                })
                .catch((error) => {
                    this.errorService.showError("There was an issue loading the page", error);
                })
        }
        nextStep() {
            try {
                this.validateInput();
            } catch (error) {
                return this.errorService.showError(error.message);
            }
            if (this.editing) {
                this.updateLandingPage();
            } else {
                this.createLandingPage();
            }
        }
        cancel() {
            this._state.go("app.landingpages", this._state.params);
        }

        createLandingPage() {
            this.landingPagesService
                .createLandingPage(this.brandId, {
                    title: this.title,
                    description: this.description,
                    startDate: this.startDate,
                    endDate: this.endDate,
                })
                .then((id) => {
                    this.notify.success("Landing page created successfully");
                    this._state.go("app.landingpages.template", {
                        ...this._state.params,
                        pageId: id
                    })
                })
                .catch((error) => {
                    this.errorService.showError(
                        "Oops! there was an issue creating this landing page. Please try again",
                        error)
                })
        }

        static MaxTitleLength = 80;
        static MaxDescriptionLength = 200;

        validateInput() {
            const errors = []
            if (!this.title) {
                errors.push("Page Title is required");
            } else {
                if (this.title.length > LandingPageDetails.MaxTitleLength) {
                    errors.push(`Page Title exceeds the maximum allowed character count (${LandingPageDetails.MaxTitleLength})`)
                }
            }
            if (!this.description) {
                errors.push("Description is required");
            } else {
                if (this.description.length > LandingPageDetails.MaxTitleLength) {
                    errors.push(`Page Description exceeds the maximum allowed character count (${LandingPageDetails.MaxTitleLength})`)
                }
            }
            if (this.startDate > this.endDate) {
                errors.push("The start date should be before the end date");
            }
            if (errors.length) {
                throw Error(errors[0])
            }
        }

        updateLandingPage() {
            this.landingPagesService.updateLandingPage(this.pageId, {
                title: this.title,
                description: this.description,
                startDate: this.startDate,
                endDate: this.endDate,
            }).then(() => {
                this.notify.success('Updated successfully');
                this._state.go("app.landingpages.template", this._state.params);
            }).catch((error) => {
                this.errorService.showError(
                    "Oops! there was an issue updating this landing page. Please try again",
                    error)
            })
        }
    }

    angular
        .module('dashboard')
        .component('landingPageDetails', {
            templateUrl: 'components/landingpages/wizard/step-1/landing-page-details.6a549380.html',
            controller: [
                '$scope',
                '$state',
                'moment',
                'notify',
                'ErrorService',
                'LandingPagesService',
                'PermissionService',
                LandingPageDetails]
        });
})();
